<template lang="pug">
.matrix
  Form(:model="formData")
    .title
      FormItem
        Input(type='textarea' placeholder='题目内容' :rows='1' v-model='formData.title')
      iDelModel(:del-model='delModel',@upData="$emit('upData')",@downData="$emit('downData')")
    .table(style='margin-left:35px')
      FormItem
        table.matrix-table
          tr
            th(v-for='(item,index) in formData.optionsList'
              :key='index' :style="{width:item.width}" ref='colOptions')
              iDropdown(v-if='index!==0'
                :content="getContent(index,'col')"
                :inputWidth = 'item.width'
                type='col'
                @change-content="changeContent(index,'col', arguments)"
                @move-left='moveLeft(index)'
                @move-right='moveRight(index)'
                @del-col='delCol(index)')
          tr(v-for='(item,index) in formData.questionsList' :key='index')
            th
              iDropdown(:content="getContent(index,'row')"
              type='row'
              @change-content="changeContent(index,'row', arguments)"
              @move-up='moveUp(index)'
              @move-down='moveDown(index)'
              @del-row='delRow(index)')
            td(:colspan='formData.optionsList.length')
              .question
                Input(type='textarea' placeholder='标题说明' v-model='item.description' autosize)
              .options
                ul
                  li(v-for='(n,i) in item.options'
                  :key='i'
                  :style='{width:formData.optionsList[i+1].width}')
                    Checkbox(v-model='n.checked' @on-change='isChecked(index,i)')
          Button(type="dashed" @click='addCol').right-btn +  添加
          Button(type="dashed" @click='addRow').bottom-btn +  添加

    .question-score
        FormItem(label='分值',label-position="right",:label-width="80")
          InputNumber(:max='100',:min='0')
    .edit-table
      Button.btn(type='text' @click='ModalOpen') 调整列宽
  //- 列表弹框
  Modal.modal(v-model='isModalOpen' width='840' footer-hide)
    p(solt='header' style='display:none')
    h2 矩阵题列宽调整
    h3(style='margin:30px 0 10px') ·矩阵单选题*
    table.modal-table(ref='modalTable')
      tr
        th(v-for='(item,index) in formData.optionsList'
          :key='index'
          :style="{width:item.width}"
          style="userSelect:none"
          ref='colOptions')
          span {{ item.col }}
      tr(v-for='(item,index) in formData.questionsList' :key='index')
        th
          span {{item.row}}
        td(v-for='(n,i) in item.options' :key='i')
          Checkbox(v-model='n.checked' @on-change='isChecked(index,i)')
    Button.modal-btn(type="primary" @click='Modal2Open') 保存
  //- 题型显示弹框
  Modal.modal2(v-model='isModal2Open' width='840' footer-hide)
    h2 {{formData.title}}
    dl(v-for='(item,index) in formData.questionsList' :key='index')
      dt {{item.row}}
      dd {{item.description}}
      dd
        ul
          li(v-for='(n,i) in getOptionsList' :key='i' :style='{width:n.width}')
              Checkbox(v-model='item.options[i].checked' @on-change='isChecked(index,i)')
              span {{n.col}}
</template>

<script>
/* eslint-disable */
import iDropdown from "@/components/common/iDropdown";
import iDelModel from "@/components/common/iDelModel";
import { findComponentDownward } from "@/utils/assist.js";
import _ from "lodash";
export default {
  components: {
    iDelModel,
    iDropdown
  },
  data() {
    return {
      formData: {
        title: "",
        optionsList: [
          {
            col: "",
            width: "100px"
          },
          {
            col: "选项1",
            width: "100px"
          },
          {
            col: "选项2",
            width: "100px"
          }
        ],
        questionsList: [
          {
            row: "矩阵行1",
            description: "",
            options: [{ checked: true }, { checked: false }]
          },
          {
            row: "矩阵行2",
            description: "",
            options: [{ checked: false }, { checked: false }]
          }
        ]
      },
      isModalOpen: false,
      isModal2Open: false,
      iDropdown: {}
    };
  },
  methods: {
    delModel() {
      this.$emit("delModel");
    },
    isChecked(index, i) {
      let checked = this.formData.questionsList[index].options[i].checked;
      checked = !checked;
    },
    // 添加行
    addRow() {
      const obj = {
        row: `矩阵行${this.formData.questionsList.length + 1}`,
        description: "",
        options: Array.from(
          { length: this.formData.optionsList.length - 1 },
          item => {
            return (item = {
              checked: false
            });
          }
        )
      };
      this.formData.questionsList.push(obj);
    },
    // 添加列
    addCol() {
      const obj = {
        col: `选项${this.formData.optionsList.length}`,
        width: "100px"
      };
      this.formData.optionsList.push(obj);
      this.formData.questionsList.forEach(item => {
        item.options.push({ checked: false });
      });
    },
    // 列左移
    moveLeft(index) {
      const qlist = this.formData.questionsList;
      const olist = this.formData.optionsList;
      let col = [];
      if (index > 1) {
        const o = olist.splice(index, 1);
        olist.splice(index - 1, 0, o[0]);
        qlist.forEach(item => {
          col = item.options.splice(index - 1, 1);
          item.options.splice(index - 2, 0, col[0]);
        });
      } else {
        this.$Message.error("已经是第一个选项");
      }
    },
    // 列右移
    moveRight(index) {
      const qlist = this.formData.questionsList;
      const olist = this.formData.optionsList;
      const len = olist.length - 1;
      let col = [];
      if (index < len) {
        const o = olist.splice(index, 1);
        olist.splice(index + 1, 0, o[0]);
        qlist.forEach(item => {
          col = item.options.splice(index, 1);
          item.options.splice(index - 1, 0, col[0]);
        });
      } else {
        this.$Message.error("已经是最后一个选项");
      }
    },
    // 删除列
    delCol(index) {
      const list = this.formData.questionsList;
      const len = this.formData.optionsList.length;
      if (len > 3) {
        this.formData.optionsList.splice(index, 1);
        list.forEach(item => {
          item.options.splice(index - 1, 1);
        });
      } else {
        this.$Message.error("至少需要保留两个选项");
      }
    },
    // 行上移
    moveUp(index) {
      const list = this.formData.questionsList;
      if (index > 0) {
        const row = list.splice(index, 1);
        list.splice(index - 1, 0, row[0]);
      } else {
        this.$Message.error("已经是第一题了");
      }
    },
    // 行下移
    moveDown(index) {
      const list = this.formData.questionsList;
      const len = list.length;
      if (index < len - 1) {
        const row = list.splice(index, 1);
        list.splice(index + 1, 0, row[0]);
      } else {
        this.$Message.error("已经是最后一题了");
      }
    },
    // 删除行
    delRow(index) {
      const list = this.formData.questionsList;
      const len = list.length;
      if (len > 1) {
        list.splice(index, 1);
      } else {
        this.$Message.error("至少需要保留一题");
      }
    },
    // 列头及行头的内容
    getContent(index, type) {
      if (type === "col") {
        let col = this.formData.optionsList[index].col;
        if (!col) {
          col = `选项${index}`;
        }
        return col;
      }
      if (type === "row") {
        let row = this.formData.questionsList[index].row;
        if (!row) {
          row = `矩阵行${index + 1}`;
        }
        return row;
      }
    },
    // 编辑标题或选项
    changeContent() {
      const index = arguments[0];
      const type = arguments[1];
      const value = arguments[2][0];
      if (type === "col") {
        this.formData.optionsList[index].col = value;
        // 根据文本内容 改变选项宽度
        setTimeout(
          _.debounce(() => {
            this.formData.optionsList[index].width =
              this.$refs.colOptions[index].getBoundingClientRect().width + "px";
          }),
          100
        );
      } else if (type === "row") {
        this.formData.questionsList[index].row = value;
      }
    },
    // 打开调整列宽表格的弹框
    ModalOpen() {
      this.isModalOpen = true;
      this.dragColWidth();
    },
    // 打开题型展示的弹框
    Modal2Open() {
      this.isModalOpen = false;
      this.isModal2Open = true;
    },
    // 列宽拖拽
    dragColWidth() {
      let self = this;
      let td; //用来存储当前更改宽度的Table Cell,避免快速移动鼠标的问题
      let table = this.$refs.modalTable;
      for (let i = 0, len = table.rows[0].cells.length; i < len; i++) {
        let item = table.rows[0].cells[i];
        let span = item.children[0];
        span.style.display = 'inline-block';
        item.onmousedown = function() {
          console.log('span',span)
          if (event.offsetX > 30) {
            td = item;
          } else if (event.offsetX < 20) {
            item = table.rows[0].cells[i - 1];
            td = item;
          }
          if (td.offsetWidth - event.offsetX < 20) {
            td.mouseDown = true;
            td.oldX = event.x;
            td.oldWidth = td.offsetWidth;
          }
        };
        item.onmouseup = function() {
          if (td == undefined) td = item;
          td.mouseDown = false;
          td.style.cursor = "default";
        };
        item.onmouseout = function() {
          if (td == undefined) td = table.rows[0].cells[i - 1];
          // if(event.offsetX)
        };
        item.onmousemove = function() {
          //更改鼠标样式
          if (event.offsetX > item.offsetWidth - 20) {
            item.style.cursor = "col-resize";
          } else {
            item.style.cursor = "default";
          }
          //取出暂存的Table Cell
          if (td == undefined) td = item;
          if (td.mouseDown != null && td.mouseDown == true) {
            td.style.cursor = "default";
            if (td.oldWidth + (event.x - td.oldX) > 0) {
              td.width = td.oldWidth + (event.x - td.oldX);
              // 列的宽度必须大于文本+padding的宽度
              if (td.width >= span.getBoundingClientRect().width+24) {
                // 当滑动到元素右边框时修改i的值
                if (event.offsetX < 20) {
                  if(i>=1){
                    self.formData.optionsList[i - 1].width = td.width + "px";
                  }
                } else {
                  self.formData.optionsList[i].width = td.width + "px";
                }
              }
            }
            td.style.cursor = "col-resize";
          }
        };
      }
      table.onmouseout = function() {
        if (td.mouseDown) {
          setTimeout(
            _.debounce(() => {
              td.mouseDown = false;
            }),
            100
          );
        }
      };
    }
  },
  computed: {
    getOptionsList() {
      return this.formData.optionsList.slice(1);
    }
  },
  mounted() {
    this.iDropdown = findComponentDownward(this, "iDropdown");
    console.log(this.iDropdown);
  }
};
</script>



<style lang="stylus">
.matrix
  width 790px
  padding 24px 16px 24px 44px
  .title
    position relative
    .ivu-form-item-content
      width 75%
  .table
    width 100%
  .matrix-table
    position relative
    // border 1px solid rgba(210, 221, 236, 1)
    border-left 1px solid rgba(210, 221, 236, 1)
    border-top 1px solid rgba(210, 221, 236, 1)
    border-radius 4px
    border-spacing 0
    overflow-x scroll
    tr
      height 32px
      th
        text-align center
        border-bottom 1px solid rgba(210, 221, 236, 1)
        border-right 1px solid rgba(210, 221, 236, 1)
        white-space nowrap
      td
        text-align center
        padding 0
        border-bottom 1px solid rgba(210, 221, 236, 1)
        border-right 1px solid rgba(210, 221, 236, 1)
        white-space nowrap
        .ivu-checkbox-inner
          border-radius 50%
    .question
      .ivu-input
        margin 0
        border none
        border-radius 0
        border-bottom 1px solid rgba(210, 221, 236, 1)
        outline 0
        &:focus
          box-shadow none
    .options
      ul
        li
          float left
          // border-top 1px solid rgba(210, 221, 236, 1)
          border-right 1px solid rgba(210, 221, 236, 1)
          // border-bottom 1px solid rgba(210, 221, 236, 1)
          &:last-child
            border-right none !important
          &:first-child
            border-left none !important
    .right-btn, .bottom-btn
      position absolute
      width 100px
      height 32px
      background rgba(255, 255, 255, 1)
      border-color rgba(58, 118, 210, 1)
      color rgba(58, 118, 210, 1)
    .right-btn
      top 0
      right -116px
    .bottom-btn
      bottom -48px
      left 0
  .question-score
    margin-top 65px
.modal
  .modal-table
    position relative
    margin-left 15px
    border 1px solid rgba(210, 221, 236, 1)
    border-radius 4px
    border-spacing 0
    overflow-x scroll
    tr
      height 32px
      th
        text-align center
        border 1px solid rgba(210, 221, 236, 1)
        white-space nowrap
      td
        text-align center
        padding 0
        border 1px solid rgba(210, 221, 236, 1)
        white-space nowrap
        .ivu-checkbox-inner
          border-radius 50%
  .modal-btn
    margin-top 10px
    margin-left 90%
.modal2
  h2
    color rgba(30, 144, 255, 1)
  dl
    overflow hidden
    dt
      margin 30px 0 10px
      color rgba(30, 144, 255, 1)
      font-size 14px
      font-weight 600
    dd
      &:nth-of-type(1)
        margin 10px 0
        font-size 14px
        font-weight 500
        color rgba(176, 196, 222, 1)
        word-wrap break-word
      ul
        margin-left 25px
        li
          float left
          .ivu-checkbox-inner
            border-radius 50%
</style>
